import { Routes, Route, Navigate } from 'react-router-dom'
import { useAuth } from './hooks/useAuth'
import { AppLayout } from './components/layout/AppLayout'
import { LoginPage } from './modules/auth/LoginPage'
import { RegisterPage } from './modules/auth/RegisterPage'
import { DashboardPage } from './modules/dashboard/DashboardPage'
import { SimulatorPage } from './modules/paie/SimulatorPage'
import { VerifyPage } from './modules/verify/VerifyPage'
import { VaultAccessPage } from './modules/vault/VaultAccessPage'
import { PayslipHistoryPage } from './modules/paie/history/PayslipHistoryPage'
import { EmployeesPage } from './modules/rh/EmployeesPage'
import { EmployeeFormPage } from './modules/rh/EmployeeFormPage'
import { DeclarationsPage } from './modules/declarations/DeclarationsPage'
import { SickLeavePage } from './modules/maladie/SickLeavePage'
import { AccountingPage } from './modules/compta/AccountingPage'
import { RunPayrollPage } from './modules/paie/RunPayrollPage'

function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { user, loading } = useAuth()

  if (loading) return null
  if (!user) return <Navigate to="/login" replace />

  return <>{children}</>
}

function PublicRoute({ children }: { children: React.ReactNode }) {
  const { user, loading } = useAuth()

  if (loading) return null
  if (user) return <Navigate to="/dashboard" replace />

  return <>{children}</>
}

export function App() {
  return (
    <Routes>
      <Route path="/login" element={<PublicRoute><LoginPage /></PublicRoute>} />
      <Route path="/register" element={<PublicRoute><RegisterPage /></PublicRoute>} />
      <Route path="/verify/:token" element={<VerifyPage />} />
      <Route path="/vault" element={<VaultAccessPage />} />
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <AppLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<Navigate to="/dashboard" replace />} />
        <Route path="dashboard" element={<DashboardPage />} />
        <Route path="payroll" element={<RunPayrollPage />} />
        <Route path="payroll/simulator" element={<SimulatorPage />} />
        <Route path="payroll/history" element={<PayslipHistoryPage />} />
        <Route path="declarations" element={<DeclarationsPage />} />
        <Route path="absences" element={<SickLeavePage />} />
        <Route path="accounting" element={<AccountingPage />} />
        <Route path="employees" element={<EmployeesPage />} />
        <Route path="employees/:id" element={<EmployeeFormPage />} />
      </Route>
    </Routes>
  )
}
